export default {"src":"/_next/static/media/image2.fe993072.svg","height":18,"width":18};